const _resources = new Map();

const ResourceContainer = {
  set_resource(name, resource) {
    _resources.set(name, resource);
  },
  get_resource(name) {
    return _resources.get(name);
  },
};

export { ResourceContainer };
